<script setup lang="ts"></script>

<template>
  <v-card elevation="1">
    <v-card-text> Розділ в розробці </v-card-text>
  </v-card>
</template>

<style scoped lang="scss"></style>
